<div class="noMatch">
    <div>
        <img src="../../assets/img/SmartLeads Logo-11.png" alt="smart-leads-logo">
    </div>

    <footer>
        <span>Copyright © 2021. Todos los derechos reservados.</span>
    </footer>
</div>